import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue'

Vue.use(VueRouter);
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText }
  from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

import VuePictureSwipe from 'vue-picture-swipe';
Vue.component('vue-picture-swipe', VuePictureSwipe);

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(NProgress);

import i18n from"./lang/i18n.js"

Vue.config.productionTip = false

import Homepage from '@/pages/Homepage.vue'
import Introduction from '@/pages/Introduction.vue'
import ServicedOffice from '@/pages/ServicedOffice.vue'
import VirtualOffice from '@/pages/VirtualOffice.vue'
import ProfessionalServices from '@/pages/ProfessionalServices.vue'
import ContactUs from '@/pages/ContactUs.vue'

const routes = [
  { path: '/', component: Homepage },
  { path: '/introduction', component: Introduction },
  { path: '/servicedoffice', component: ServicedOffice },
  { path: '/virtualoffice', component: VirtualOffice },
  { path: '/professionalservices', component: ProfessionalServices },
  { path: '/contactus', component: ContactUs }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done()
})

new Vue({
  render: h => h(App),
  i18n,
  router,
}).$mount('#app')
